class AddonItem extends HTMLElement {
  constructor() {
    super()
    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer')
    this.form = this.querySelector('form')
    this.submitButton = this.querySelector('button[type="submit"]')

    this.paramHandle()

    if (this.submitButton === null) {
      return
    }

    this.submitButton.addEventListener('click', (evt) => {
      evt.preventDefault()
      evt.stopImmediatePropagation()

      this.classList.add('loading')
      this.submitButton.classList.add('loading')

      const config = fetchConfig('javascript')
      config.headers['X-Requested-With'] = 'XMLHttpRequest'
      delete config.headers['Content-Type']

      const formData = new FormData(this.form)
      if (this.cart) {
        formData.append(
          'sections',
          this.cart.getSectionsToRender().map((section) => section.id),
        )
        formData.append('sections_url', window.location.pathname)
        this.cart.setActiveElement(document.activeElement)
      }
      config.body = formData

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.errors || response.description,
              message: response.message,
            })
            this.handleErrorMessage(response.description)

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message')
            if (!soldOutMessage) return
            this.submitButton.setAttribute('aria-disabled', true)
            this.submitButtonText.classList.add('hidden')
            soldOutMessage.classList.remove('hidden')
            this.error = true
            return
          } else if (!this.cart) {
            window.location = window.routes.cart_url
            return
          }

          const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers')
          if (!this.error)
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              cartData: response,
            }).then(() => {
              CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker)
            })
          this.error = false
          const quickAddModal = this.closest('quick-add-modal')
          if (quickAddModal) {
            document.body.addEventListener(
              'modalClosed',
              () => {
                setTimeout(() => {
                  CartPerformance.measure('add:paint-updated-sections', () => {
                    this.cart.renderContents(response)
                  })
                })
              },
              { once: true },
            )
            quickAddModal.hide(true)
          } else {
            CartPerformance.measure('add:paint-updated-sections', () => {
              this.cart.renderContents(response)
            })
          }
        })
        .catch((e) => {
          console.error(e)
        })
        .finally(() => {
          this.submitButton.classList.remove('loading')
          if (this.cart && this.cart.classList.contains('is-empty'))
            this.cart.classList.remove('is-empty')
          if (!this.error) this.submitButton.removeAttribute('aria-disabled')
          if (this.querySelector('.loading__spinner') !== null) {
            this.querySelector('.loading__spinner').classList.add('hidden')
          }
          CartPerformance.measureFromEvent('add:user-action', evt)
        })
    })
  }

  paramHandle() {
    if (typeof this.dataset.gwpSecret === 'undefined') {
      return
    }

    let itemParam = this.dataset.gwpSecret
    const tcSecretGift = getCookie('tc_secret_gift')
    let paramEligible = false
    if (tcSecretGift !== null && itemParam.toLowerCase() === tcSecretGift.toLowerCase()) {
      paramEligible = true
    }
    if (paramEligible) {
      const itemCountElement = this.closest('[data-addon-item-count]')
      itemCountElement.dataset.addonItemCount =
        parseInt(itemCountElement.dataset.addonItemCount) + 1
    } else {
      // this.style.opacity = '.2'
      this.remove()
    }
  }
}
if (!customElements.get('addon-item')) {
  customElements.define('addon-item', AddonItem)
}

class GwpSwitch extends HTMLElement {
  constructor() {
    super()
    this.querySelector('button').addEventListener('click', (evt) => {
      evt.preventDefault()
      this.closest('.addon-items')
        .querySelectorAll('addon-item[data-gwp-filter]')
        .forEach((item) => {
          if (item.dataset.gwpFilter === this.dataset.gwpFilter) {
            item.classList.remove('hidden')
          } else {
            item.classList.add('hidden')
          }
        })
    })
  }
}
if (!customElements.get('gwp-switch')) {
  customElements.define('gwp-switch', GwpSwitch)
}
